"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smsTypes = void 0;
var smsTypes;
(function (smsTypes) {
    smsTypes["WELCOME"] = "welcome";
    smsTypes["KIT_ARRIVAL"] = "kitArrival";
    smsTypes["FINAL_2_DAYS"] = "final2Days";
    smsTypes["FINAL_5_DAYS"] = "final5Days";
    smsTypes["FINAL_10_DAYS"] = "final10Days";
    smsTypes["FINAL_20_DAYS"] = "final20Days";
    smsTypes["LAST_CHANCE"] = "lastChance";
    smsTypes["FOLLOW_UP_3"] = "followUp3";
    smsTypes["FOLLOW_UP_2"] = "followUp2";
    smsTypes["FOLLOW_UP_1"] = "followUp1";
    smsTypes["VERIFICATION"] = "verification";
    smsTypes["DELIVERY"] = "delivery";
    smsTypes["APP_DOWNLOAD_VIDEO"] = "appDownloadVideo";
    smsTypes["CONTACT_DETAILS"] = "contactDetails";
    smsTypes["DOWNLOAD_APP"] = "downloadApp";
    smsTypes["POST_CONSULTATION"] = "postConsultation";
    smsTypes["REMINDER_1"] = "reminder1";
    smsTypes["REMINDER_2"] = "reminder2";
    smsTypes["REMINDER"] = "reminder";
    smsTypes["NEXT_VISIT_SMS_REMINDER"] = "nextVisitSmsReminder";
    smsTypes["REMINDER_NEAR_END"] = "reminderNearEnd";
    smsTypes["ENDING_SOON"] = "endingSoon";
    smsTypes["FOLLOW_UP_1_B"] = "followUp1B";
    smsTypes["END_OF_SERVICE"] = "endOfService";
    smsTypes["WELCOME_WITH_CKD"] = "welcomeWithCKD";
    smsTypes["FOLLOW_UP_WITH_CKD"] = "followUpWithCKD";
    smsTypes["FOLLOW_UP_WITHOUT_CKD"] = "followUpWithoutCKD";
    smsTypes["WELCOME_WITHOUT_CKD"] = "welcomeWithoutCKD";
    smsTypes["CONSENT_TO_SMSES"] = "consentToSmses";
    smsTypes["REMINDER_TWO"] = "reminderTwo";
    smsTypes["REMINDER_ONE"] = "reminderOne";
    smsTypes["WARMUP"] = "warmup";
    smsTypes["WARMUP_CALL_FIRST"] = "warmupCallFirst";
    smsTypes["FINAL_2_DAYS_NO_BRANCH"] = "final2DaysNoBranch";
    smsTypes["FINAL_3_DAYS"] = "final3Days";
    smsTypes["REMINDER_THREE"] = "reminderThree";
    smsTypes["REMINDER_THREE_NO_BRANCH"] = "reminderThreeNoBranch";
    smsTypes["REMINDER_ONE_NO_BRANCH"] = "reminderOneNoBranch";
    smsTypes["UPDATE_DATA"] = "updateData";
    smsTypes["RESULTS"] = "results";
    smsTypes["SECOND_KIT_ARRIVED"] = "secondKitArrived";
    smsTypes["SECOND_KIT_DELIVERY"] = "secondKitDelivery";
    smsTypes["FINAL_LAST_DAYS"] = "finalLastDays";
    smsTypes["FINAL_3_WEEKS"] = "final3Weeks";
    smsTypes["OPEN_DIALER_KIDNEY_SOLUTIONS"] = "openDialerKidneySolutions";
    smsTypes["OPEN_DIALER_SUPPORT"] = "openDialerSupport";
    smsTypes["POST_TEST"] = "postTest";
    smsTypes["POST_TEST_1"] = "postTest1";
    smsTypes["POST_TEST_2"] = "postTest2";
    smsTypes["POST_TEST_3"] = "postTest3";
    smsTypes["POST_TEST_SURVEY"] = "postTestSurvey";
    smsTypes["CALENDAR_REMINDER"] = "calendarReminder";
})(smsTypes || (exports.smsTypes = smsTypes = {}));
